/**
 * Absolute paths owned by the post domain. Imported from navigations,
 * pages, and any consumer that needs to `<Link to={...} />` or
 * `navigate(...)` to a post-domain route. Keeping the paths in one
 * object avoids magic strings drifting between the router and callers.
 */
export const POST_ROUTES = {
	feed: "/feed",
	feedDetailPattern: "/feed/:id",
	feedDetail: (id: string) => `/feed/${id}` as const,
	appFeed: "/app/feed",
	appFeedDetailPattern: "/app/feed/:id",
	appFeedDetail: (id: string) => `/app/feed/${id}` as const,
} as const;
